var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isIE)?_c('IEScreen'):_c('AgeGate')}
var staticRenderFns = []

export { render, staticRenderFns }